export const parseTime = (time) => {
	// Split the time string into hours, minutes, and seconds
	const timeParts = time.split(":");
	let hours = parseInt(timeParts[0], 10);
	const minutes = parseInt(timeParts[1], 10);

	// Determine whether it's AM or PM
	const suffix = hours >= 12 ? "PM" : "AM";

	// Convert hours to 12-hour format
	hours %= 12;
	hours = hours || 12; // "0" should be displayed as "12"

	// Construct the formatted time string
	return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${suffix}`;
};

export const labelHour = (time) => {
	if (time?.appointmentOnly) {
		return "By Appointment Only";
	}

	if (time.open === time.closed || time.open === "-" || time.closed === "-") {
		return "Closed";
	}

	const openTime = parseTime(time.open);
	const closeTime = parseTime(time.closed);

	return `${openTime} – ${closeTime}`;
};
